import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { IProgram } from '@/types/program';
  import { reactive, inject, nextTick, ref } from 'vue';
  import _ from 'lodash';
  import { useRouter } from 'vue-router';
  import { authStore } from '@/stores';
  import { ColorVariants } from '@/constants';
  import Apply from './apply.vue';
  import { goToLogin, request } from '@/utils';

  interface IProps {
    program: IProgram;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IProgram;
  }

  const router = useRouter();
  
  const applyRef = ref();
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;

  const dialog = reactive({
    login: false,
    email: false,
    address: false,
    info: false,
  });

  const dialogTipMessage = ref('');

  function closeDialog(dialogName?: string) {
    if (dialogName) {
      dialog[dialogName] = false;
    } else {
      _.forEach(dialog, (val, key) => {
        if (val) {
          dialog[key] = false;
        }
      });
    }
  }

  function showDialog(dialogName: string) {
    closeDialog();
    dialog[dialogName] = true;
  }

  function showTipDialog(message: string) {
    dialogTipMessage.value = message;
    showDialog('info');
  };

  function login() {
    closeDialog();
    goToLogin();
  }

  function verify() {
    closeDialog();
    router.push({ name: 'mine.memberProfile.edit', query: { type: 'email' } });
  };

  function navToProfileEdit() {
    closeDialog();
    router.push({ name: 'mine.memberProfile.edit' });
  };

  const check = async () => {
    if (!authStore.isLogin) {
      showDialog('login');
      return false;
    }
    await authStore.tryFetchData();
    const emailVerified = _.get(authStore, 'user.profile.email_verified');
    if (!emailVerified) {
      showDialog('email');
      return false;
    }
    if (!authStore.canParticipateProgram) {
      showDialog('address');
      return false;
    }
    return true;
  };

  // 1. participation_request_id 为空，则调用participate接口，接口成功后返回program详情信息
  //   （1）show_collection_btn = true, 则调用collection接口
  //   （2）show_collection_btn = false，显示participation_msg
  // 2. participation_request_id 不为空，则不调用participate接口，跟第1点一样两步判断
  // 3. 直接apply
  const apply = async () => {
    const canApply = await check();
    if (canApply) {
      await refreshPageData();
      await nextTick();
      // program类型没有participate按钮，但是要先生成participate记录
      if (!props.program.participation_request_id) {
        // 只调一下 不传参数
        try {
          await request.post(`programs/${props.program.id}/participate`, {}, { loading: { silent: true } });
        } catch (e) {
          const errorMsg = _.get(e, 'message');
          showTipDialog(errorMsg);
          throw e;
        }
        await refreshPageData();
        await nextTick();
      }
      if (props.program.show_collection_btn) {
        applyRef.value.start();
      } else {
        showTipDialog(props.program.participate_btn_msg as string);
      }
    }
  };


return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).login,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).login) = $event)),
        class: "dialog-emart",
        btns: [
        { text: '로그인', style: _unref(ColorVariants).dark, click: login }
      ],
        title: "가플지우!",
        content: "로그인 해주세요"
      }, null, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).email,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).email) = $event)),
        class: "dialog-emart",
        btns: [
        { text: '이메일 인증하기', style: _unref(ColorVariants).dark, click: verify }
      ],
        title: "가플지우!",
        content: "이메일 인증이 필요합니다."
      }, null, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).address,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).address) = $event)),
        class: "dialog-emart",
        btns: [
        { text: '확인', style: _unref(ColorVariants).dark, click: navToProfileEdit }
      ],
        title: "가플지우!",
        content: "마이페이지에서 주소 및 휴대폰 번호를 확인해주세요"
      }, null, 8, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).info,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialog).info) = $event)),
        class: "dialog-emart",
        btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ],
        title: "가플지우!",
        content: dialogTipMessage.value
      }, null, 8, ["visible", "btns", "content"])
    ])),
    _createVNode(Apply, {
      ref_key: "applyRef",
      ref: applyRef,
      program: __props.program
    }, null, 8, ["program"]),
    _renderSlot(_ctx.$slots, "default", { apply: apply })
  ], 64))
}
}

})